// Redux store configuration

import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { baseApi } from './api/baseApi'
import authReducer from './slices/authSlice'
import uiReducer from './slices/uiSlice'

export const store = configureStore({
  reducer: {
    // Add the API reducer
    [baseApi.reducerPath]: baseApi.reducer,
    // Add slice reducers
    auth: authReducer,
    ui: uiReducer,
  },
  // Add the API middleware
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
})

// Setup listeners for refetchOnFocus and refetchOnReconnect
setupListeners(store.dispatch)

// Export types
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Export API hooks
export * from './api/authApi'
export * from './api/farmApi'
export * from './api/cowApi'
export * from './api/transactionApi'
export * from './api/behaviorApi'
export * from './api/estrusApi'
export * from './api/notificationApi'
export * from './api/farmerApi'
export * from './api/heatAlertApi'

// Export slice actions (with renamed exports to avoid conflicts)
export {
  setCredentials,
  setUser,
  logout as authLogout,
  setLoading as setAuthLoading,
  selectCurrentUser,
  selectIsAuthenticated,
  selectAuthToken,
  selectAuthLoading,
} from './slices/authSlice'

export {
  toggleSidebar,
  setSidebarCollapsed,
  openModal,
  closeModal,
  setModalData,
  setLoading as setUILoading,
  clearLoading,
  selectSidebarCollapsed,
  selectModal,
  selectLoading,
} from './slices/uiSlice'
